<template>
  <ld-persistent-banner
    :warningIcon="true"
    class="banner-ms-migration"
    v-if="needReconnection"
    :error="true"
    :text="text"
    :complete="false"
    :loading="true"
    :link="redirectUrl"
    buttonText="RECONNECT NOW"
  >
  </ld-persistent-banner>
</template>
<script>
import LdPersistentBanner from './LdPersistentBanner';
import { HC_PROPS } from 'lion-vue-src/_globals';
export default {
  components: { LdPersistentBanner },
  props: {
    needReconnection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
        visible: false,
    };
  },
  mounted() {
    this.visible = this.needReconnection;
  },
  computed: {
    redirectUrl() {
      return `${HC_PROPS.PLATFORM_APP_URL}/email-integrations`;
    },
    text() {
      return `<strong>Action Required: Update Your Email Sync!</strong> To continue using email sync in LionDesk, please reconnect your email accounts (Gmail, Office365, or other third-party accounts) now. This update will improve security and help protect your account. Admin approval may be required.`;
    },
  },
  watch: {
    visible: {
        handler() {
            this.$emit('show', this.visible);
        },
    },
    needReconnection: {
        handler() {
            this.$emit('show', this.needReconnection);
        },
    },
  },
};
</script>
<style lang="scss">
  .banner-ms-migration {
    height: auto !important;
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
</style>
